import { apiFetch } from './client';

export const userAPI = {
  getAll: (params) => apiFetch(`/admin/users${params ? '?' + new URLSearchParams(params) : ''}`),
  getById: (id) => apiFetch(`/admin/users/${id}`),
  create: (data, role = 'USER') => apiFetch(`/admin/users?role=${role}`, { method: 'POST', body: JSON.stringify(data) }),
  update: (id, data) => apiFetch(`/admin/users/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  updateStatus: (id, status) => apiFetch(`/admin/users/${id}/status?status=${status}`, { method: 'PATCH' }),
  resetPassword: (id, password) => apiFetch(`/admin/users/${id}/password`, { method: 'PATCH', body: JSON.stringify({ password }) }),
  delete: (id) => apiFetch(`/admin/users/${id}`, { method: 'DELETE' }),
};

export const salespersonAPI = {
  getAll: () => apiFetch('/salespersons'),

  getById: (id) => apiFetch(`/salespersons/${id}`),

  create: (data) =>
      apiFetch('/salespersons', {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  update: (id, data) =>
      apiFetch(`/salespersons/${id}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),

  updateStatus: (id, status) =>
      apiFetch(`/salespersons/${id}/status?status=${status}`, { method: 'PATCH' }),

  delete: (id) =>
      apiFetch(`/salespersons/${id}`, { method: 'DELETE' }),

  getReferrals: (id) => apiFetch(`/salespersons/${id}/referrals`),

  addReferral: (id, data) =>
      apiFetch(`/salespersons/${id}/referrals`, {
        method: 'POST',
        body: JSON.stringify(data),
      }),

  getStats: () => apiFetch('/salespersons/stats'),

  getDetailStats: (id) => apiFetch(`/salespersons/${id}/detail-stats`),

  updateCommission: (id, rate) =>
      apiFetch(`/salespersons/${id}/commission?rate=${rate}`, { method: 'PATCH' }),

  updateSettlement: (referralId, status) =>
      apiFetch(`/salespersons/referrals/${referralId}/settlement?status=${status}`, { method: 'PATCH' }),

  resetPassword: (id, password) =>
      apiFetch(`/salespersons/${id}/password`, {
        method: 'PATCH',
        body: JSON.stringify({ password }),
      }),

  checkLoginId: (loginId) => apiFetch(`/salespersons/check-login-id?loginId=${encodeURIComponent(loginId)}`),
};

export const salespersonMyAPI = {
  getMyInfo: () => apiFetch('/salesperson/me'),
  getMyReferrals: () => apiFetch('/salesperson/me/referrals'),
  getMyDetailStats: () => apiFetch('/salesperson/me/detail-stats'),
  changeMyPassword: (data) =>
      apiFetch('/salesperson/me/password', {
        method: 'PATCH',
        body: JSON.stringify(data),
      }),
};

export const salespersonClientAPI = {
  getClients: () => apiFetch('/salesperson/me/clients'),
  getClientDetail: (accountId) => apiFetch(`/salesperson/me/clients/${accountId}`),
  getContentSettings: (accountId) => apiFetch(`/salesperson/me/clients/${accountId}/content-settings`),
  updateContentSettings: (accountId, data) =>
      apiFetch(`/salesperson/me/clients/${accountId}/content-settings`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
  getSchedule: (accountId) => apiFetch(`/salesperson/me/clients/${accountId}/schedule`),
  updateSchedule: (accountId, data) =>
      apiFetch(`/salesperson/me/clients/${accountId}/schedule`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
  getPosts: (accountId) => apiFetch(`/salesperson/me/clients/${accountId}/posts`),
  getKeywords: (accountId) => apiFetch(`/salesperson/me/clients/${accountId}/keywords`),
  getCalendars: (accountId) => apiFetch(`/salesperson/me/clients/${accountId}/calendars`),
  getCalendar: (accountId, calId) => apiFetch(`/salesperson/me/clients/${accountId}/calendars/${calId}`),
  updateCalendarPost: (accountId, calId, postId, data) =>
    apiFetch(`/salesperson/me/clients/${accountId}/calendars/${calId}/posts/${postId}`, {
      method: 'PUT', body: JSON.stringify(data),
    }),
  deleteCalendarPost: (accountId, calId, postId) =>
    apiFetch(`/salesperson/me/clients/${accountId}/calendars/${calId}/posts/${postId}`, {
      method: 'DELETE',
    }),
};

export const adminCalendarAPI = {
  list: (accountId) => apiFetch(`/admin/calendars?accountId=${accountId}`),
  getById: (id) => apiFetch(`/admin/calendars/${id}`),
  updatePost: (calId, postId, data) =>
    apiFetch(`/admin/calendars/${calId}/posts/${postId}`, {
      method: 'PUT', body: JSON.stringify(data),
    }),
  deletePost: (calId, postId) =>
    apiFetch(`/admin/calendars/${calId}/posts/${postId}`, { method: 'DELETE' }),
};

export const adminGenerationRuleAPI = {
  get: (accountId) => apiFetch(`/admin/accounts/${accountId}/generation-rule`),
  reset: (accountId) => apiFetch(`/admin/accounts/${accountId}/generation-rule/reset`, { method: 'POST' }),
};

export const adminPromptAPI = {
  getAll: () => apiFetch('/admin/prompt-templates'),
  getByType: (type) => apiFetch(`/admin/prompt-templates/${type}`),
  update: (type, data) =>
      apiFetch(`/admin/prompt-templates/${type}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
};

export const cleanupAPI = {
  cleanupImages: (daysOld = 30) =>
      apiFetch(`/admin/cleanup/images?daysOld=${daysOld}`, { method: 'POST' }),
  cleanupFailedUploads: () =>
      apiFetch('/admin/cleanup/failed-uploads', { method: 'POST' }),
};

export const dmAutoReplyAPI = {
  getConfig: (accountId) => apiFetch(`/dm-auto-reply/account/${accountId}`),
  updateConfig: (configId, data) =>
      apiFetch(`/dm-auto-reply/${configId}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
  toggleEnabled: (configId) =>
      apiFetch(`/dm-auto-reply/${configId}/toggle`, { method: 'PATCH' }),
  addKeywordReply: (data) =>
      apiFetch('/dm-auto-reply/keyword-replies', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
  updateKeywordReply: (replyId, data) =>
      apiFetch(`/dm-auto-reply/keyword-replies/${replyId}`, {
        method: 'PUT',
        body: JSON.stringify(data),
      }),
  deleteKeywordReply: (replyId) =>
      apiFetch(`/dm-auto-reply/keyword-replies/${replyId}`, { method: 'DELETE' }),
};
